import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const MANGALIK_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [],
  [SupportedLanguage.Hindi]: [],
  [SupportedLanguage.Bengali]: [],
  [SupportedLanguage.Telugu]: [],
  [SupportedLanguage.Marathi]: ['नाही', 'होय', 'अंशिक', 'माहित नाही'],
  [SupportedLanguage.Tamil]: [],
  [SupportedLanguage.Gujarati]: [],
  [SupportedLanguage.Kannada]: [],
  [SupportedLanguage.Malayalam]: [],
  [SupportedLanguage.Odia]: [],
}
